import * as React from "react"
import styles from "./InputCaption.module.scss"

import DsButton from "@components/general/DsButton/DsButton.tsx"

interface IProps {
	className?: string
	text: string
	onClick?: () => void
}

const InputCaption: React.FC<IProps> = (props) => {
	return (
		<DsButton
			className={`${styles.input_caption} ${props.className || ""}`}
			onClick={props.onClick}
			type="text"
		>
			{props.text}
		</DsButton>
	)
}

export default React.memo(InputCaption)
